(() => {
  'use strict';
  const redirect = document.querySelector('[data-bl-archive-search-redirect]');
  const searchResults = document.querySelector('[data-bl-archive-search-results]');
  if (!redirect && !searchResults) return;
  const current = new URL(window.location.href);
  const target = new URL(current.href);
  let queryChanged = false;
  if (redirect) {
    const fallback = new URL(redirect.dataset.blSearchUrl, current.origin);
    if (fallback.origin !== current.origin) return;
    queryChanged = current.pathname !== fallback.pathname;
    target.pathname = fallback.pathname;
    if (queryChanged) target.searchParams.set('q', fallback.searchParams.get('q') || '');
  }
  const availabilityChanged = target.searchParams.get('options[unavailable_products]') !== 'hide';
  target.searchParams.set('options[unavailable_products]', 'hide');
  target.searchParams.set('view', 'bl-available');
  if (!target.searchParams.has('type')) target.searchParams.set('type', 'product');
  if (availabilityChanged || queryChanged) target.searchParams.delete('page');
  if (target.href !== current.href) window.location.replace(target.href);
})();
